import React, { useEffect, useState } from 'react'
import {render} from 'react-dom'
import "./style.scss";

import {AddressFinder} from "../../src";
import { getCookie, setCookie } from "../../src/utils/cookies";
import useDevControls from "./useDevControls";

const Demo = () => {
    const [DevControlsElement, visibleColumnLabels, visibleDataLabels, showOnlyLowestLevelAddresses, showAdditionalFilters] = useDevControls()

    return (
        <div className="container">
            {DevControlsElement}

            <AddressFinder
                visibleColumnLabels={visibleColumnLabels}
                visibleDataLabels={visibleDataLabels}
                showOnlyLowestLevelAddresses={showOnlyLowestLevelAddresses}
                showAdditionalFilters={showAdditionalFilters}
                apiBaseEndpointUri={'https://amk.viss.gov.lv/rest'}
                onInputChange={(event)=>{
                    console.log("onInputChange:",event.target.value)
                }}
                onItemSelect={(payload)=>{
                    console.log("onItemSelect:",payload?.data?.code, payload)
                }}
                highlightMatches={true}
            />
        </div>
    )
}

render(<Demo/>, document.querySelector('#demo'))
